export const tenants = '/app/tenants';
export const tenantDetail = '/app/tenants/:tenantId';

export const buildTenantDetail = (tenantId) => {
  return `/app/tenants/${tenantId}`;
};